<h2 class="_sansSerif _primary"[i18nKey]="'evaluations.tabs.GENERAL_INFORMATION'"></h2>

<kiwi-spacer [size]="24"></kiwi-spacer>

<div>
    <h3 class="_secondary"[i18nKey]="'evaluations.general.information.description'"></h3>

    <p>
        <strong [i18nKey]="'evaluations.general.information.part1'"></strong> <span [i18nKey]="'evaluations.general.information.part2'"></span></p>

    <kiwi-spacer [size]="12"></kiwi-spacer>

    <ul>
<!--        <li [innerHTML]="'evaluations.general.information.subPart1'|translate" [i18nKey]="[{target: 'innerHTML', key: 'evaluations.general.information.subPart1'}]"></li>-->
<!--        <kiwi-spacer [size]="8"></kiwi-spacer>-->
        <li [innerHTML]="'evaluations.general.information.subPart2'|translate" [i18nKey]="[{target: 'innerHTML', key: 'evaluations.general.information.subPart2'}]"></li>
        <kiwi-spacer [size]="8"></kiwi-spacer>
        <li [innerHTML]="'evaluations.general.information.subPart3'|translate" [i18nKey]="[{target: 'innerHTML', key: 'evaluations.general.information.subPart3'}]"></li>
    </ul>

    <kiwi-spacer [size]="24"></kiwi-spacer>

    <p>
        <strong class="_primary"[i18nKey]="'evaluations.general.information.title.part4'"></strong>
        <br /> <span [i18nKey]="'evaluations.general.information.part4'"> </span></p>
</div>

